var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGenericMapfreWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 469 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ffffff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.7,16.8c-8.2,0-14.5,2.5-19.1,7.6-3.8-5-9.4-7.6-17-7.6s-12.2,2.2-15.9,6.6v-5.5h-11.4v40h12v-26.1c2.3-3.1,6.4-4.7,12.1-4.7,8.2,0,12.1,3.2,12.1,10.2v20.6h12v-26.1c2.3-3.1,6.4-4.7,12.1-4.7,8.2,0,12.1,3.2,12.1,10.2v20.6h12v-20.6c0-12.8-7.8-20.4-20.9-20.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.8,23.4c-4.3-4.1-11.3-6.6-18.6-6.6-13.8,0-23.7,8.7-23.7,21s9.8,21,23.7,21,14.2-2.5,18.6-6.6v5.5h11.4V17.9h-11.4v5.5ZM269.2,43.2c-3.4,3.6-8.7,5.5-15.4,5.5s-14.2-4.1-14.2-10.8,5.3-10.8,14.2-10.8,12.1,1.9,15.4,5.5v10.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396,23.4v-5.5h-11.4v40h12v-26.1c1.9-3.2,5.6-4.7,11.6-4.7s5.4.2,7.7.8l1-10.3c-1-.5-3-.7-5.8-.7-6.4,0-12.1,2.5-15,6.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462.8,45.6c-4.6,2.3-11.5,3.8-17.8,3.8-10.4,0-15.2-2.5-16-8.2h36.6c.3-2.2.5-3.6.5-5.3,0-11.2-9.4-19-23.1-19s-25.4,7.7-25.4,21,9.5,21.1,26.6,21.1,18.2-2.4,22.7-5.8l-4.2-7.6ZM443,25.6c7.6,0,11.9,2.6,12.7,7.8h-26.7c.9-5.4,5.1-7.8,14-7.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.8,18.3v39.6h12v-30.4h17.8v-9.6h-17.8v-.8c0-5.2,2.8-7.2,10.1-7.2s6.5.4,11.2,1.1l.8-8.5c-3.9-1.1-8.2-1.7-13.2-1.7-13.9,0-20.9,5.8-20.9,17.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M319.1,16.8c-7.3,0-14.2,2.5-18.6,6.6v-5.5h-11.4v53.3h12v-18.8c4.2,4.1,10.9,6.6,17.9,6.6,13.8,0,23.7-8.7,23.7-21s-9.8-21-23.7-21ZM316.6,48.7c-6.7,0-12.1-1.9-15.4-5.5v-10.6c3.4-3.6,8.7-5.5,15.4-5.5s14.2,4.1,14.2,10.8-5.3,10.8-14.2,10.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.5,19c0-10.1-8.1-18.2-18.2-18.2s-18.3,8-18.3,18.2,5.1,18.7,14.4,26.3l-.3.2C29,32.5,17.6,28.1,10.1,28.1S1,31.9,1,37.2c0,11,13.4,21.8,27.3,21.8,23.5,0,49.2-20.9,49.2-39.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.3,28.1c-8.6,0-19.5,5.2-45.4,21.8,12.4,6.6,19.8,9,27.2,9,13.8,0,27.3-10.7,27.3-21.8s-3.8-9-9-9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGenericMapfreWhite);
export default __webpack_public_path__ + "static/media/logo-generic-mapfre-white.efcccbbe50a0eaa1e90f3137febf1ec6.svg";
export { ForwardRef as ReactComponent };